<template lang="pug">
  td.col.marking(:class="company.marked ? 'on' : ''")
    span(@click="toggle") マーキング

</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    props: ['company', 'updateMarkForIndex'],
    data () {
      return {
        marked: this.company.marked,
      }
    },
    computed: {
      ...mapState({
        user: state => state.user.detail,
      }),
    },
    methods: {
      ...mapActions('jobMark', ['add', 'remove']),
      async toggle () {
        if (this.company.marked) {
          if (this.company.job_mark_user !== this.user.name) {
            return
          }
        }

        this.$store.commit('common/lockGlobal')
        try {
          this.company.marked
            ? await this.remove({ id: this.company.company_id })
            : await this.add({ id: this.company.company_id })

          if (this.updateMarkForIndex) {
            this.$store.commit('company/mark', { ids: this.company.company_id, newMarked: !this.company.marked, markUser: this.user.name })
          }
          this.$store.commit('common/unlockGlobal')
          this.$emit('update')
        } catch (e) {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CompanyTableMark.vue